import { useState } from 'react';

interface UseOverlaidTooltip {
	isOpen: boolean;
	toggleTooltip: () => void;
}

export const useOverlaidTooltip = (initialIsOpen = false): UseOverlaidTooltip => {
	const [isOpen, setIsOpen] = useState(initialIsOpen);

	const toggleTooltip = () => setIsOpen((prev) => !prev);

	return {
		isOpen,
		toggleTooltip,
	};
};
